import { ApiService } from './api.service';
import { AuthGuard } from './auth-guard.service';
import { UserService } from './user.service';
import { ErrorHandlerService } from './error-handler.service';
import { HttpCacheService } from './http-cache.service';
import { LayoutService } from './layout.service';
import { NavigationService } from './navigation.service';
import { PreviousRouteService } from './previous-route.service';
import { RoutePartsService } from './route-parts.service';
import { ThemeService } from './theme.service';
import { ToastService } from './toast.service';
import { MatchMediaService } from './match-media.service';
import { LanguageService } from './language.service';
import { ConfigService } from './config.service';
import { PermissionService } from './permission.service';
import { RedirectService } from './redirect.service';
import { GenerateRouteService } from './generate-route.service';
import { MessagingService } from './messaging.service';
import { DietitianService } from './dietitan.service';
import { DietitianAuthGuard } from './dietitian-auth-guard.service';
import { PhysioService } from './physio.service';
import { PhysioAuthGuard } from './physio-auth-guard.service';
import { AppLoaderService } from './app-loader.service';

export const serviceProvider = [
    ApiService, 
    AuthGuard,
    AppLoaderService,
    MessagingService,
    GenerateRouteService,
    UserService,
    DietitianService,
    DietitianAuthGuard,
    PhysioService,
    PhysioAuthGuard,
    ErrorHandlerService,
    HttpCacheService,
    LayoutService,
    NavigationService,
    PreviousRouteService,
    RoutePartsService,
    ThemeService,
    ToastService,
    MatchMediaService,
    LanguageService,
    ConfigService,
    PermissionService,
    RedirectService,
];